import axios from 'axios';
import notifyConfigure from 'components/Toast';
import { checkStatus } from './checkStatus';
import { getBaseURL } from './getBaseURL';

const baseURLAPIS = getBaseURL().base;

let initialToastfy = {
	error: false,
	success: false,
};

export default class HttpClient {
	constructor() {
		this.client = axios.create({
			baseURL: baseURLAPIS,
			headers: {
				'Content-Type': 'application/json',
			},
		});
	}

	get(url, config = null, isToastfy = initialToastfy) {
		return this.client.get(url, config).then((res) => {
			notifyConfigure(res?.data?.Status, res?.data?.Success, res.data?.Message, isToastfy);

			return res;
		});
	}

	post(url, params, config, isToastfy = initialToastfy) {
		// eslint-disable-next-line no-console
		console.log('params', params, config);

		return this.client.post(url, params, config).then((res) => {
			checkStatus(res?.data?.Status);
			notifyConfigure(res?.data?.Status, res?.data?.Success, res.data?.Message, isToastfy);

			return res;
		});
	}

	delete(url, config = null, isToastfy = initialToastfy) {
		return this.client.delete(url, config).then((res) => {
			notifyConfigure(res?.data?.Status, res?.data?.Success, res.data?.Message, isToastfy);

			return res;
		});
	}
	put(url, params, config = null, isToastfy = initialToastfy) {
		return this.client.put(url, params, config).then((res) => {
			notifyConfigure(res?.data?.Status, res?.data?.Success, res.data?.Message, isToastfy);

			return res;
		});
	}
}
